import { Injectable } from '@angular/core';

import { IWorkflowDefinitionSearchResultRecord, SearchBody } from '@assess/shared/data-mart-search';

import { SearchService } from './search.service';

@Injectable({ providedIn: 'root' })
export class WorkflowDefinitionSearchService {
  private readonly resourceType = 'workflow-definitions';

  constructor(private readonly searchService: SearchService) {}

  search(workflowType: string) {
    return this.searchService.search<IWorkflowDefinitionSearchResultRecord>(
      this.resourceType,
      this.buildSearchBody(workflowType)
    );
  }

  buildSearchBody(workflowType: string): SearchBody {
    return {
      filters: {
        application: 'Assess',
        workflowType,
      },
      paging: { size: 1_000 },
      sortFields: [{ field: 'name' }],
    };
  }
}
